module.exports = __webpack_public_path__ + "img/equipe.aad07b02.png";